import { SVGProps, Ref, forwardRef } from 'react';

export const PlusOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.1 11.1V4h1.8v7.1H20v1.8h-7.1V20h-1.8v-7.1H4v-1.8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlusOutlinedSize24Glyph.displayName = 'PlusOutlinedSize24Glyph';
